import { CheckCircle2 } from 'lucide-react';

export default function TargetAudience() {
  const audiences = [
    {
      title: "مصممو الجرافيك (مستوى متوسط)",
      desc: "الطموحين للانتقال من تنفيذ الأشكال إلى منهجية النظام البصري الاحترافي."
    },
    {
      title: "مصممو الشعارات",
      desc: "الراغبين في توسيع خدماتهم من مجرد شعار إلى هوية كاملة لرفع قيمتهم في السوق."
    },
    {
      title: "طلاب وخريجو التصميم",
      desc: "المحتاجين لبناء مشروع بورتفوليو واحد متكامل وقوي بدلاً من أعمال متفرقة."
    },
    {
      title: "المصممون المستقلون (Freelancers)",
      desc: "الباحثين عن Workflow احترافي لتقليل التعديلات العشوائية وإقناع العميل."
    }
  ];

  return (
    <section className="py-32 relative bg-slate-50 dark:bg-zinc-950 transition-colors duration-500 border-t border-slate-200 dark:border-white/5">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2 transition-colors duration-500">
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
            الجمهور المستهدف
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-6 leading-[1.3] drop-shadow-sm dark:drop-shadow-lg transition-colors duration-500">
            هل هذه <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 via-primary-500 to-primary-700 dark:from-primary-400 dark:via-primary-500 dark:to-primary-600">الدورة لك؟</span>
          </h3>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {audiences.map((item, idx) => (
            <div key={idx} className="bg-white/70 dark:bg-zinc-900/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-lg p-8 md:p-10 hover:-translate-y-2 transition-all duration-500 group relative overflow-hidden shadow-sm hover:shadow-xl dark:shadow-[0_10px_30px_rgba(0,0,0,0.3)] hover:border-primary-500/40 dark:hover:border-primary-500/50 flex gap-6">

              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/5 dark:bg-primary-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700 ease-out blur-[30px] pointer-events-none"></div>

              <div className="shrink-0 mt-1 relative z-10">
                <div className="w-12 h-12 rounded-full bg-slate-100 dark:bg-zinc-800 border border-slate-200 dark:border-white/10 flex items-center justify-center group-hover:bg-primary-50 dark:group-hover:bg-primary-900/30 group-hover:border-primary-200 dark:group-hover:border-primary-500/30 transition-colors duration-300">
                  <CheckCircle2 className="w-6 h-6 text-primary-600 dark:text-primary-500 transform group-hover:scale-110 transition-transform duration-300" />
                </div>
              </div>

              <div className="relative z-10">
                <h4 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white mb-3 transition-colors duration-500 leading-snug">{item.title}</h4>
                <p className="text-base md:text-lg text-slate-600 dark:text-zinc-400 leading-relaxed font-medium transition-colors duration-500">{item.desc}</p>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
